<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Inventario por vendedor y ventas
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span>Inventario por vendedor y ventas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Vendedor" formControlName="vendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
      </div>

      <h5 style="border-bottom: 1px solid #dee2e6">IPT</h5>

      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="lunes" [checked]="true">Lunes</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="martes" [checked]="false"><span style="font-size: 1rem">Martes</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="miercoles" [checked]="false"><span style="font-size: 1rem">Miercoles</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="jueves" [checked]="false"><span style="font-size: 1rem">Jueves</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="viernes" [checked]="false"><span style="font-size: 1rem">Viernes</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="sabado" [checked]="false"><span style="font-size: 1rem">Sábado</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="domingo" [checked]="false"><span style="font-size: 1rem">Domingo</span>
          </mdb-checkbox>
        </div>
        <div class="col" style="max-width: 150px">
          <mdb-checkbox formControlName="todos" [checked]="false"><span style="font-size: 1rem">Todos</span>
          </mdb-checkbox>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>


<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 25%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>

<div class="card mb-2 wow" *ngIf="listaMaquinas?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('PDF')">
      PDF
    </button>
  </div>
</div>


<section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;">
  <div class="card mb-2 wow"  style="z-index: 1;">
    <div class="card-body"  *ngIf="listaMaquinas">

      <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

      <div class="">
        <table class="table TablePrincipal table-striped table-hover table-sm align-middle" *ngIf="listaMaquinas?.length > 0">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" style="width: 100px;">RUT</th>
              <th scope="col" style="width: 15%;">Nombre</th>
              <th scope="col" style="width: 15%;">Dirección</th>
              <th scope="col" style="width: 8%;">Comuna</th>
              <th scope="col" style="width: 10%;">Ciudad</th>
              <th scope="col" style="width: 8%;">N° Placa</th>
              <th scope="col" style="width: 10%;">Marca</th>
              <th scope="col" style="width: 75px;">Modelo</th>
              <th scope="col" style="width: 75px;">Estado</th>
              <th scope="col" style="width: 75px;">Cod. Vend.</th>
              <th scope="col" style="width: 10%;">Nombre Vend.</th>
              <th scope="col" style="width: 75px;">IPT</th>
              <th scope="col" style="width: 75px;">Total Maq.</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let mov of listaMaquinas">
              <td *ngIf="mov.cliente_proveedor_rut != 0">{{mov.rutFormato_cliente | rut}}</td>
              <td *ngIf="mov.cliente_proveedor_rut === 0"></td>
              <td>{{mov.cliente_proveedor_nombre}}</td>
              <td>{{mov.direccion}}</td>
              <td>{{mov.nombre_comuna}}</td>
              <td>{{mov.nombre_ciudad}}</td>
              <td>{{mov.placa}}</td>
              <td>{{mov.marca}}</td>
              <td>{{mov.modelo}}</td>
              <td>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 1" pill="true" success="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 2" pill="true" info="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 3" pill="true" warning="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 4" pill="true" danger="true">{{mov.estado}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 0" pill="true" danger="true">{{mov.estado}}</mdb-badge>
              </td>
              <td *ngIf="mov.vendedor_codigo != 0">{{mov.vendedor_codigo}}</td>
              <td *ngIf="mov.vendedor_codigo === 0"></td>
              <td>{{mov.nombre_vendedor}}</td>
              <td>{{mov.dia}}</td>
              <td *ngIf="mov.conteo != 0">{{mov.conteo}}</td>
              <td *ngIf="mov.conteo === 0"></td>
            </tr>
            <tr>
              <td colspan="100%" style="text-align: center">
                <div class="row pb-1 pt-1" id="spinnerX">
                  <div class="col-md-12 p-4">
                    <ngx-spinner
                    bdColor=""
                    bdoOpacity="0.9"
                    size="default"
                    color="#581f87"
                    type="ball-pulse-sync"
                    [fullScreen]="false"
                    >
                  </ngx-spinner>

                  </div>
               </div>
              </td>

            </tr>
          </tbody>
          <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMaquinas?.length > 0"></app-pagination> -->
            <tfoot *ngIf="listaMaquinas?.length > 0">
              <tr>
                <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
                <th colspan="12">
                  {{ PagPosActual }} de  {{ totalPagPos }} ({{
                    totalRegistrosPos
                  }}
                  registros)

                </th>
              </tr>
            </tfoot>
          </table>
      </div>
    </div>
  </div>

</section>




